module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/quantum-phone-video-poster.1ba54e90.png";